import axios from "axios";

const state = {
    token: localStorage.getItem('token') || '',
    user: {}
}

const getters = {
    isLoggedIn: state => !!state.token,

    user (state) {
        return state.user
    }
}

const mutations = {

    auth_success(state, { user, token }) {
        state.token = token
        state.user = user
    },

    logout(state) {
        state.token = ''
        state.user = {}
    },
}

const actions = {
    login({ commit }, user) {
        return new Promise((resolve, reject) => {
            axios({ url: '/login-admin', data: user, method: 'POST' })
                .then(resp => {

                    const token = resp.data.meta.token
                    const user = resp.data.data
                    localStorage.setItem('token', token)
                    axios.defaults.headers.common['Authorization'] = token
                    commit('auth_success', { user, token })

                    resolve(resp)

                })
                .catch(err => {
                    localStorage.removeItem('token')
                    reject(err)
                })
        })
    },

    logout({ commit }) {
        return new Promise((resolve) => {
            commit('logout')
            localStorage.removeItem('token')
            delete axios.defaults.headers.common['Authorization']
            resolve()
        })
    },

}



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
